export default __webpack_public_path__ + "media/images/features/ana/papers-01cf8322dc62c62cb0d4feee039213c4.png";